module.exports = __webpack_public_path__ + "img/msg-left.cc7eadb1.png";